import moment from "moment"
import _ from "lodash"
export abstract class CashFlowPlanDetail {
    data
    customAmounts
    dates = []
    todayMonthIndice:number = moment().month()
    companyId:string = ""
    budgetId:string = null
    initializeDone:boolean = false

    budgets:number[] = []

    constructor(companyId, budgetId, data, customAmounts={}) {
        this.companyId = companyId
        this.budgetId = budgetId || null
        this.data = data
        this.customAmounts = customAmounts
    }

    abstract upsertManualBudgetAccountingLine(accountingLine)

    initialize() {
        if (this.initializeDone) {
            return
        }
        this.initializeDone = true
        if (!this.data) {
            debugger // git-ignore
            return
        }
        for (const date of this.data.dates) {
            this.dates.push(moment(date).format("YYYY-MM"))
        }
    }

    addKeyRows(keyRows, columns, index, key, row) {
        if (index >= columns.length) {
            return
        }
        let inKey = key
        let fatherRowKey
        if (inKey) {
            fatherRowKey = inKey
            inKey += "/"
        }
        inKey += columns[index]
        let keyRow = keyRows[inKey]
        if (keyRow) {
            for (let vi = 0; vi < row.budget.length; vi++) {
                keyRow.budget[vi] += row.budget[vi]
            }
            for (let vi = 0; vi < row.cashFlow.length; vi++) {
                keyRow.cashFlow[vi] += row.cashFlow[vi]
            }
        } else {
            keyRow = _.cloneDeep(row)
            keyRow.name = columns[index]
            keyRows[inKey] = keyRow
        }
        if (fatherRowKey) {
            const fatherRow = keyRows[fatherRowKey]
            if (fatherRow) {
                if (!fatherRow.subRows) {
                    fatherRow.subRows = [keyRow]
                    fatherRow.expanded = false
                } else {
                    fatherRow.subRows.push(keyRow)
                }
                keyRow.isChild = true
            } else {
                debugger
            }
        }
        this.addKeyRows(keyRows, columns, index+1, inKey, row)
    }

    computeTree(fromTag:boolean=false) {
        //
        // create tree and compute balance
        //
        if (!this.data.operatingAccount) {
            if (fromTag) {
                const keyRows = {}
                for (const row of this.data.names) {
                    const columns = row.name.split("/")
                    this.addKeyRows(keyRows, columns, 0, "", row)
                }

                this.data.names = []
                for (const key in keyRows) {
                    if (!keyRows[key].isChild) {
                        this.data.names.push(keyRows[key])
                    }
                }
            }
            else if (this.data.names) {
                for (const row of this.data.names) {
                    this.computeRowKey(row)
                }
                this.addSubRowsFromDetails(this.data.names, false)
                this.computeFolderBalances(this.data.names)
            }
        } else {
            this.addSubRowsFromDetails(this.data.operatingAccount.rows, true)
            for (const row of this.data.operatingAccount.rows) {
                if (row.subRows) {
                    row.expanded = false
                }
            }

            for (const detail of this.data.details.names) {
                if (!detail.used) {
                    console.error("detail not found key= " + detail.key)
                }
            }
            //
            // clean tree
            //
            for (let ri = this.data.operatingAccount.rows.length-1; ri >=0 ; ri--) {
                const row = this.data.operatingAccount.rows[ri]
                if (!row.subRows.length) {
                    this.data.operatingAccount.rows.splice(ri,1)
                } else if (row.subRows?.length === 1 && row.subRows[0].subRows?.length) {
                    row.subRows = row.subRows[0].subRows
                }
            }
            this.computeFolderBalances(this.data.operatingAccount.rows)
        }
    }

    build() {
        if (!this.data) {
            debugger // git-ignore
            return
        }
        //
        // create tree
        //
        if (!this.data.operatingAccount) {
            if (this.data.names) {
                this.computeFolderBudget(this.data.names)
            }
        } else {
            this.computeFolderBudget(this.data.operatingAccount.rows)
        }
    }

    computeRowKey(row) {
        if (row.key) {
            return
        }
        row.key = row.name
        if (row.thirdPartyName) {
            row.key += "_" + row.thirdPartyName
        } else if (row.userId) {
            row.key += "_" + row.userId
        }
    }

    addSubRowsFromDetails(firstLevelRows, addInSubRows:boolean) {
        if (this.data?.details?.names) {
            for (const detail of this.data.details.names) {
                if (detail.used) {
                    continue
                }
                this.computeRowKey(detail)

                let row
                if (!addInSubRows) {
                    row = firstLevelRows.find(row => detail.name.startsWith(row.name) )
                } else {
                    for (const firstLevelRow of firstLevelRows) {
                        if (firstLevelRow.subRows) {
                            row = firstLevelRow.subRows.find(row => detail.name.startsWith(row.name) )
                            if (row) {
                                break
                            }
                        }
                    }
                }
                if (!row) {
                    // debugger
                    row = {
                        bsk: null,
                        key: detail.name,//detail.key,
                        name: detail.name,
                        displayName: detail.displayName,
                        description: detail.description,
                        // thirdPartyCompanyId: detail.thirdPartyCompanyId,
                        // thirdPartyCompanyName: detail.thirdPartyCompanyName,
                        // userId: detail.userId,
                        // thirdPartyName: detail.thirdPartyName,
                        budget: Array(this.dates.length).fill(0.0),
                        cashFlow: Array(this.dates.length).fill(0.0)
                    }
                    firstLevelRows.push(row)
                }
                if (row) {
                    detail.used = true
                    if (!row.subRows) {
                        row.subRows = [detail]
                        row.expanded = false
                    } else {
                        row.subRows.push(detail)
                    }
                }
            }
        }
    }

    computeFolderBalances(detailTable) {
        //
        //
        //
        for (const row of detailTable) {
            if (row.subRows) {
                row.balance = 0
                for (const subRow of row.subRows) {
                    if (subRow.subRows) {
                        subRow.balance = 0
                        for (const subSubRow of subRow.subRows) {
                            subRow.balance += subSubRow.balance || 0
                        }
                    }
                    row.balance += subRow.balance || 0
                }
            }
        }
    }

    computeFolderBudget(detailTable) {
        this.budgets = Array(this.dates.length).fill(0.0)
        for (let mi = 0; mi < this.dates.length; mi++) {
            for (const row of detailTable) {
                if (row.subRows) {
                    row.budget[mi] = 0
                    for (const subRow of row.subRows) {
                        if (subRow.subRows) {
                            subRow.budget[mi] = 0
                            for (const subSubRow of subRow.subRows) {
                                subRow.budget[mi] += this.getBudgetAmount(subSubRow, mi) || 0
                            }
                        }
                        const ba = this.getBudgetAmount(subRow, mi) || 0
                        row.budget[mi] += ba
                        this.budgets[mi] += ba
                    }
                }
            }
        }
    }


    getKey(row:any, mi:number) {
        const key = row.key + "_" + this.dates[mi]
        return key
    }

    getAmount(row:any, mi:number) {
        if (mi < this.todayMonthIndice) {
            return row.cashFlow[mi]
        }
        return this.getTotalBudgetAmount(row, mi)
    }

    getTotalBudgetAmount(row:any, mi:number) {
        const key = this.getKey(row, mi)
        const customAmount = this.customAmounts[key]
        if (customAmount) {
            // let amount =  (this.budgetId ? row.budget[mi] : customAmount.budgetAmount) || 0
            return (customAmount.budgetAmount || 0) + (customAmount.inLateAmount || 0)
            // return amount
        }
        return row.budget[mi]
    }

    getBudgetAmount(row:any, mi:number) {
        const key = this.getKey(row, mi)
        const customAmount = this.customAmounts[key]
        if (customAmount) {
            // return  (this.budgetId ? row.budget[mi] : customAmount.budgetAmount) || 0
            return customAmount.budgetAmount
        }
        return row.budget[mi]
    }


    getInLateAmount(row:any, mi:number) {
        const key = this.getKey(row, mi)
        const customAmount = this.customAmounts[key]
        if (customAmount) {
            return customAmount.inLateAmount || 0
        }
        return 0
    }

    isCustomAmount(row, mi:number) {
        const key = this.getKey(row, mi)
        if (key) {
            const customAmount = this.customAmounts[key]
            return customAmount !== undefined && customAmount !== null
        }
        return false
    }

    async setCustomAmount(cell) {
        const key = this.getKey(cell.row, cell.mi)
        let customAmount = this.customAmounts[key]
        if (customAmount) {
            // if (!this.budgetId) {
                customAmount.budgetAmount = cell.budgetAmount
            // }
            customAmount.inLateAmount = cell.inLateAmount
        } else {
            customAmount = {
                // previousValue: cell.previousValue,
                budgetAmount: cell.budgetAmount,
                inLateAmount: cell.inLateAmount,
                modified: true
            }
            this.customAmounts[key] = customAmount
        }
        const date = moment(this.dates[cell.mi]).endOf("month").startOf("day").utc(true).format()

        const al = {
            id: cell.accountingLineId,
            amountSigned: customAmount.budgetAmount + customAmount.inLateAmount,
            accountableAccount: !cell.row.tagId ? {name: cell.row.name}:undefined,
            date,
            wording: "",
            thirdPartyCompanyId: cell.row.thirdPartyCompanyId,
            thirdPartyCompanyName: cell.row.thirdPartyCompanyName,
            userId: cell.row.userId,
            tagId: cell.row.tagId
        }

        const output = await this.upsertManualBudgetAccountingLine(al)
        if (!this.budgetId && output.budgetId) {
            this.budgetId = output.budgetId
        }
        if (!cell.accountingLineId && output?.accountingLineId) {
            cell.accountingLineId = output.accountingLineId
        }

        this.build()
    }


    getTotalInLateAmount(row) {
        let totalInLateAmount = 0
        for (let mi = this.todayMonthIndice; mi < row.budget.length; mi++) {
            totalInLateAmount += this.getInLateAmount(row, mi)

        }
        return totalInLateAmount
    }

    getInLateBalance(row) {
        if (row.balance) {
            return row.balance - this.getTotalInLateAmount(row)
        }
        return 0
    }
}
